<template>
  <div :class="w?'col-'+w:'col'">
    <div class="form-floating">

      <textarea v-if="type=='textarea'" v-model="inputVal" :disabled="disabled || !$parent.edit" ref="input" class="form-control" style="height: auto" :rows="rows || 5"/>
      <select v-else-if="type=='select'" v-model="inputVal" :disabled="disabled || !$parent.edit" ref="input" class="form-select">
        <slot/>
      </select>
      <div v-else-if="type=='switch'" class="form-check form-switch">
        <input class="form-check-input" type="checkbox" v-model="inputVal" ref="input" :disabled="disabled || !$parent.edit">
        <label class="form-check-label">{{ label }}</label>
      </div>
      <input v-else v-model="inputVal" :type="type" :disabled="disabled || !$parent.edit" ref="input" class="form-control" autocomplete="off">

      <label v-if="type!='switch'">{{ label }}</label>

    </div>
  </div>

</template>

<script>
export default {
  name: "FInput",
  props: ["label", "modelValue", "w", "type", "disabled", "rows"],
  computed: {
    inputVal: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit('update:modelValue', val);
      }
    },

  }
}
</script>

